import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import UserMenu from '../../UserMenu';
import { Sheet } from '../ui/Sheet';
import { FooterContent } from '../Footer/FooterContent';
import './Header.css';

const SHOW_LOGIN_UI = (process.env.REACT_APP_REQUIRE_LOGIN_FOR_COMPARISON || 'true').toString().toLowerCase() === 'true';

const NAV_ITEMS = [
  { to: '/institution-list', label: 'Institutionsliste', match: (path) => path === '/institution-list' || path.startsWith('/institutioner/') },
  { to: '/map', label: 'Institutionskort', match: (path) => path === '/map' },
  { to: '/om', label: 'Om', match: (path) => path === '/om' },
];

function NavLink({ to, label, isActive, onNavigate, className = '' }) {
  return (
    <Link
      to={to}
      className={`nav-link ${isActive ? 'active' : ''} ${className}`.trim()}
      onClick={onNavigate}
    >
      {isActive && <span className="nav-indicator" />}
      {label}
    </Link>
  );
}

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia('(max-width: 768px)').matches : false
  );
  const location = useLocation();

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 768px)');
    const handler = () => setIsMobile(mq.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  const closeMenu = () => setIsMenuOpen(false);

  const mobileNavContent = (
    <nav className="main-nav-sheet" aria-label="Hovednavigation">
      {NAV_ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          label={item.label}
          isActive={item.match(location.pathname)}
          onNavigate={closeMenu}
          className="nav-link--sheet"
        />
      ))}
      {SHOW_LOGIN_UI && (
        <UserMenu variant="sheet" onNavigate={closeMenu} />
      )}
      <FooterContent variant="sheet" onNavigate={closeMenu} />
    </nav>
  );

  return (
    <>
      <header className="app-header">
        <div className="nav-container">
          <div className="logo-container">
            <Link to="/" className="brand-link">
              <img
                src="https://sadaycaresolution.blob.core.windows.net/media/images/logo/logo64x64.png"
                alt="Vuggestueguiden"
                className="logo"
              />
              <span className="app-title">vuggestueguiden.dk</span>
            </Link>
          </div>

          {isMobile ? (
            <button
              type="button"
              className={`menu-toggle icon-button ${isMenuOpen ? 'open' : ''}`}
              aria-label={isMenuOpen ? 'Luk menu' : 'Åbn menu'}
              aria-expanded={isMenuOpen}
              onClick={() => setIsMenuOpen((prev) => !prev)}
            >
              <span className="bar" />
              <span className="bar" />
              <span className="bar" />
            </button>
          ) : (
            <nav className="main-nav main-nav--desktop" aria-label="Hovednavigation">
              {NAV_ITEMS.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  label={item.label}
                  isActive={item.match(location.pathname)}
                  onNavigate={closeMenu}
                />
              ))}
              {SHOW_LOGIN_UI && <UserMenu />}
            </nav>
          )}
        </div>
      </header>

      {isMobile && (
        <Sheet open={isMenuOpen} onClose={closeMenu}>
          <div className="ui-sheet-scroll">{mobileNavContent}</div>
        </Sheet>
      )}
    </>
  );
};

export default Header;
